module.exports = __webpack_public_path__ + "static/maps-section-cloud-3-fff4dccf01fa67709a1c24a070363f6f.png";